import { escapeHtml } from "../escapeHtml";

export const lomdaEmbedCode = (publicUrl: string, title: string) =>
    `<iframe src="${escapeHtml(publicUrl)}" width="100%" height="720" style="border:0" allow="fullscreen" allowfullscreen loading="lazy" title="${escapeHtml(title)}"></iframe>`;
